/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 15:12:36
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-07-01 16:13:46
 */
import common from "../../common/common";
import { routerFor } from "../../common/other";
import configData from "../../config/config";
import recursionRouter from "../../router/add-router";
import router from "../../router/index";
import { getPermission } from "../../api/api-basic";
const state = {
    isLogin: false,
    winOnresize: false,
    isGetRouter: false,
    keepAliveList: [],
    goRouter: [],
    toData: {},
    routerList: [],
    userInfo: {},
    menuIndex: 0,
    menuList: [],
    pageLoading: false,
};
const getters = {};
const mutations = {
    /**
     * 是否登录
     * @param state
     * @param status 状态
     */
    SET_ISLOGIN(state, status) {
        state.isLogin = status;
    },
    /**
     * 窗口变化是改变
     * @param state
     */
    SET_WINONRESIZE(state) {
        state.winOnresize = !state.winOnresize;
    },
    /**
     * 动态添加路由
     * @param {*} state
     * @param {objAny[]} list 后台返回的菜单
     */
    SET_ROUTERLIST(state, list) {
        const routerList = recursionRouter(list); // eslint-disable-line
        //动态添加路由
        router.addRoutes(routerList);
        state.routerList = routerList;
        state.isGetRouter = true;
    },
    /**
     * 路由变化时执行,保存经过的路由,最多5个,用在tag标签和缓存路由
     * @param {*} state
     * @param {objAny} data 经过路由的数据
     */
    SET_GOROUTER(state, data) {
        let isAdd = true;
        const list = state.goRouter;
        list.map((item) => {
            if (item.url == data.url) {
                isAdd = false;
            }
        });
        if (isAdd) {
            list.push(data);
            if (list.length > 5) {
                list.splice(0, 1);
            }
            state.goRouter = list;
        }
        const keepAliveList = [];
        list.map((item) => {
            if (item.componentsName) {
                keepAliveList.push(item.componentsName);
            }
        });
        state.keepAliveList = keepAliveList;
    },
    /**
     *  删除路由 tag
     * @param {*} state
     * @param {number} index
     */
    UP_GOROUTER(state, index) {
        const list = state.goRouter;
        list.splice(index, 1);
        state.goRouter = list;
        const keepAliveList = [];
        list.map((item) => {
            keepAliveList.push(item.componentsName);
        });
        state.keepAliveList = keepAliveList;
    },
    /**
     * 当前的路由
     * @param {*} state
     * @param {objAny} data
     */
    SET_TODATE(state, data) {
        state.toData = data;
    },
    /*
     * 是否经过路由初始化
     * @param {*} state
     * @param {boolean} status
     */
    SET_ISGETROUTER(state, status) {
        state.isGetRouter = status;
    },
    /**
     * 登录信息
     * @param {*} state
     * @param {objAny} data
     */
    SET_USERINFO(state, data) {
        state.userInfo = data;
    },
    /**
     * 登录信息
     * @param {*} state
     * @param {objAny} data
     */
    SET_MENULIST(state, list) {
        state.menuList = routerFor(list);
    },
    SET_PAGELOADING(state, status) {
        state.pageLoading = status;
    },
};
const forMenuChild = function (list) {
    let str = "";
    list.map((item, index) => {
        if (index == 0) {
            if (item.children && item.children.length > 0) {
                str = forMenuChild(item.children);
            }
            else {
                str = item.url;
            }
        }
    });
    return str;
};
const actions = {
    /**
     * 路由初始化
     * @param {*} { commit, state }
     * @param {objAny} obj
     */
    async getRouter({ commit }, obj) {
        const loginData = common.get("sys_loginData");
        const win = window;
        if (loginData) {
            commit("SET_ISLOGIN", true);
            commit("SET_USERINFO", loginData);
            let toUrl = obj.to.fullPath;
            const ret = await getPermission({ roleId: loginData.rolePkId });
            if (ret.status === configData.apiStatus) {
                const data = [];
                ret.data.map((item) => {
                    if (item.modulePkId == configData.sysModulePkId) {
                        data.push(item);
                    }
                });
                // 登录进来，首页还没有做的时候
                if (toUrl == "/") {
                    toUrl = forMenuChild(data);
                }
                commit("SET_MENULIST", data);
                commit("SET_ROUTERLIST", data);
            }
            obj.next &&
                obj.next({
                    path: toUrl,
                });
        }
        else {
            commit("SET_ISGETROUTER", false);
            commit("SET_ISLOGIN", false);
            if (configData.loginUrl && configData.loginUrl != "") {
                win.location.href = configData.loginUrl;
            }
            else {
                obj.next({
                    path: "/login",
                });
            }
        }
        win.onresize = common.debounce(() => {
            commit("SET_WINONRESIZE", true);
        }, 200);
    },
};
export default {
    state,
    mutations,
    actions,
    getters,
};
